// this.$store.state.guia
import { serverTimestamp } from "firebase/firestore";

// CLASE GUIA
export const guia = class {
  constructor() {
    return {
      id: "",
      idUsuario: "",
      modulos: {
        inicio: false,
        usuario: {
          notificaciones: false,
          perfil: {
            ver: false,
            editar: false,
          },
          empresas: {
            ver: false,
            lista: false,
          },
          codigoQR: false,
          soporte: false,
          solicitudesVinculacion: {
            crear: false,
            lista: false,
          },
        },
        empresas: {
          inicio: false,
          crearEmpresa: false,
          misEmpresas: false,
          horarios: {
            lista: false,
            crear: false,
            editar: false,
          },
          vinculaciones: {
            lista: false,
            crear: false,
            editar: false,
          },
          desvinculaciones: false,
          invitaciones: {
            lista: false,
            crear: false,
          },
          misRegionales: {
            lista: false,
            crear: false,
            editar: false,
          },
        },
        controlPersonal: {
          inicio: false,
          registroManual: false,
          lectorQR: false,
          historialDiario: false,
          estadisticas: false,
          ausentismo: false,
        },
        capacitaciones: {
          inicio: false,
          cursos: {
            ver: false,
            crear: {
              generales: false,
              contenido: false,
              evaluacion: false,
            },
            editar: false,
            lista: false,
          },
          estadisticas: false,
        },
        seguridadVial: {
          inicio: false,
          infografias: false,
          conductores: {
            activos: false,
            inactivos: false,
            crear: false,
          },
          vehiculos: {
            lista: false,
            crear: false,
          },
          formatos: {
            lista: false,
            crear: false,
          },
          inspecciones: {
            lista: false,
            crear: false,
            planAccion: false,
          },
          mantenimientos: {
            lista: false,
            crear: false,
          },
          siniestralidadVial: {
            lista: false,
            crear: false,
          },
        },
      },
      registro: {
        estado: "Creado",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};
